import React from 'react';
import Image from 'gatsby-image';
import { Link } from 'gatsby';
import moment from 'moment';

const CategorizesPosts = ({ categoryPosts }) => {
  return (
    <section className='blog-one'>
      <div className='container'>
        <div className='row'>
          {categoryPosts.map((node) => {
            return (
              <div
                className='col-lg-4 col-md-6 col-sm-12 wow fadeInUp'
                key={node.id}
              >
                <div className='blog-one__single'>
                  <div className='blog-one__image'>
                    <Image
                      fluid={node.image.childImageSharp.fluid}
                      alt={node.title}
                    />{' '}
                    <Link
                      to={`/blog/${node.category}/${node.slug}`}
                      className='blog-one__more-link'
                    >
                      <i className='fa fa-link'></i>
                    </Link>
                  </div>
                  <div className='blog-one__content'>
                    <ul className='list-unstyled blog-one__meta'>
                      <li>
                        <a href='#none'>
                          {moment(node.date).format('DD MMM, YYYY')}
                        </a>
                      </li>
                    </ul>
                    <h3 className='blog-one__title'>
                      <Link to={`/blog/${node.category}/${node.slug}`}>
                        {node.title}
                      </Link>
                    </h3>
                    <Link
                      to={`/blog/${node.category}/${node.slug}`}
                      className='blog-one__link'
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategorizesPosts;
